import { BodyLarge, Description, Heading3 } from '@casavo/base-ui'
import { useRouter } from 'next/router'
import React from 'react'

import ButtonCircleIcon from '@/components/ButtonCircleIcon'
import Chevron from '@/components/Icon/Chevron'
import VirtualTour from '@/components/Icon/VirtualTour'
import { ContextValue } from '@/context/Cities'
import { DeviceType } from '@/context/Device'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'

import ModalHeaderTitle from '../ModalHeaderTitle'
import { detailModalContent, submitButton, submitRow } from '../style.css'

import { detailModalHeaderFullScreen } from './styles.css'

type Props = {
  cities: ContextValue
  city: string
  closeModal: () => void
  device: DeviceType
  language: Locale
  listingDetailUrl?: string
  slug: string
  t: any
  title: string
  virtualTourUrl: string
}

export const ModalVirtualTour: React.FC<Props> = ({
  cities,
  city,
  closeModal,
  device,
  listingDetailUrl,
  slug,
  t,
  title,
  virtualTourUrl,
}) => {
  const router = useRouter()
  const listingCity = cities.list.find((item) => item.slug === city)
  const modalType = 'show-virtual-tour'

  return (
    <>
      <div className={detailModalContent}>
        <div className={detailModalHeaderFullScreen}>
          {device === 'desktop' ? (
            <>
              <ModalHeaderTitle cityName={listingCity.translatedCityName} closeModal={closeModal} title={title} />
              <div
                className={sprinkles({
                  alignItems: 'center',
                  display: 'flex',
                })}
              >
                <VirtualTour className={sprinkles({ marginRight: 's' })} />
                <BodyLarge>{t('common:cta_show_virtual_tour')}</BodyLarge>
              </div>
            </>
          ) : (
            <>
              <ButtonCircleIcon
                ariaLabel="close dialog"
                className={sprinkles({ marginRight: 'm' })}
                onClick={() => closeModal()}
              >
                <Chevron className={sprinkles({ transform: 'rotate(90deg)' })} />
              </ButtonCircleIcon>

              <div>
                <Heading3 className={sprinkles({ paddingBottom: 'xs' })} color="white">
                  {t('common:cta_show_virtual_tour')}
                </Heading3>
                <Description color="white">{title}</Description>
              </div>
            </>
          )}
        </div>
        <div className={sprinkles({ height: '100%', paddingY: { tablet: 'l' } })}>
          <iframe
            allowFullScreen
            className="lazyload"
            frameBorder="0"
            height="100%"
            src={virtualTourUrl}
            title={`${slug}_vt`}
            width="100%"
          ></iframe>
          {listingDetailUrl && (
            <div className={submitRow}>
              <div
                className={submitButton}
                onClick={() => {
                  document.body.classList.remove('fixed-body')
                  router.push(listingDetailUrl)
                }}
              >
                {t('common:view_property')}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
